import store from '@/redux/store'

const ABSOLUTE_URL = /^(https?:)?\/\//i
const URL_BASE = 'https://emma.local'

const getAppRootPath = (_settings) => {
	/* If this func is called before redux state init */
	const settings = _settings || store.getState().settings

	const { custom_domainYN, url_root_path } = settings || {}
	const rootPath = String(url_root_path || '').replace(/^\/+|\/+$/g, '')

	return custom_domainYN || !rootPath ? '' : `/${rootPath}`
}

const hasRootPrefix = (pathname, root) => pathname === root || pathname.startsWith(`${root}/`)

/**
 * Prefix the event root (`/emma`) when the API/router path omits it.
 * Leaves the path unchanged when the root is already present, on custom domains,
 * or when `path` is an absolute URL.
 */
export const withAppRootPath = (path) => {
	if (!path || typeof path !== 'string') return path
	if (ABSOLUTE_URL.test(path)) return path

	const root = getAppRootPath()
	const url = new URL(path, URL_BASE)
	let { pathname } = url

	if (root && !hasRootPrefix(pathname, root)) {
		pathname = `${root}${pathname}`
	}

	return `${pathname}${url.search}${url.hash}`
}

export const withoutAppRootPath = (path) => {
	if (!path || typeof path !== 'string') return path
	if (ABSOLUTE_URL.test(path)) return path

	const root = getAppRootPath()
	if (!root) return path

	const url = new URL(path, URL_BASE)
	if (!hasRootPrefix(url.pathname, root)) return path

	const pathname = url.pathname.slice(root.length) || '/'
	return `${pathname}${url.search}${url.hash}`
}

export default getAppRootPath
